import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {FormControl, InputLabel, MenuItem, Paper, Select, TextField} from "@mui/material";
import TableBody from "@mui/material/TableBody";
import React, {useState} from "react";
import {MainTitle} from "../pages/BuhPage/styles";
import { getMonthByDate } from "../pages/ProfilePage/ProfilePage";
import {formatNumber} from "../utils/numbers";
import {Link} from "react-router-dom";

export interface DataRow {
    name: string;
    date: string;
    payed: boolean;
    income: number;
    cost: number;
    isSolder?: boolean,
    id?: string,
}

export default function FilterableTable({ incomeData = [] } : { incomeData : DataRow[] }) {
    const [filters, setFilters] = useState({
        name: '',
        date: '',
        payed: 'all',
    });

    const handleFilterChange = (field: string, value: string) => {
        setFilters(prev => ({ ...prev, [field]: value }));
    };

    const filteredData = incomeData.filter(row =>
        row.name.toLowerCase().includes(filters.name.toLowerCase()) &&
        (filters.date === '' || row.date.toString().includes(filters.date)) &&
        (
            filters.payed === 'all' ||
            (filters.payed === 'true' && row.payed) ||
            (filters.payed === 'false' && !row.payed)
        )
    );

    return (
        <>
            <MainTitle variant="h4" sx={{marginBottom: '20px', mt:4}}>Таблица расходов / доходов</MainTitle>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <TextField
                                    label="ФИО усопшего"
                                    variant="standard"
                                    value={filters.name}
                                    onChange={(e) => handleFilterChange('name', e.target.value)}
                                />
                            </TableCell>
                            <TableCell>
                                <TextField
                                    label="Дата создания"
                                    variant="standard"
                                    value={filters.date}
                                    onChange={(e) => handleFilterChange('date', e.target.value)}
                                />
                            </TableCell>
                            <TableCell>
                            </TableCell>
                            <TableCell>
                            </TableCell>
                            <TableCell>
                                <FormControl variant="standard" fullWidth>
                                    <InputLabel>Оплачено</InputLabel>
                                    <Select
                                        value={filters.payed}
                                        onChange={(e) => handleFilterChange('payed', e.target.value)}
                                        label="Оплачено"
                                    >
                                        <MenuItem value="all">Все</MenuItem>
                                        <MenuItem value="true">Оплачено</MenuItem>
                                        <MenuItem value="false">Не оплачено</MenuItem>
                                    </Select>
                                </FormControl>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell><strong>ФИО усопшего</strong></TableCell>
                            <TableCell><strong>Дата создания</strong></TableCell>
                            <TableCell><strong>Доходы</strong></TableCell>
                            <TableCell><strong>Расходы</strong></TableCell>
                            <TableCell><strong>Оплачено</strong></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredData.map((row, index) => {
                            const date = new Date(row.date);
                            // const dateString = `${date.getDate() + 1}.${date.getMonth()}.${date.getFullYear()}`
                            const dateString = date.toLocaleDateString("ru-RU", { // you can use undefined as first argument
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit",
                            })
                            const link =`/change/${row.id}`;
                            return (
                                <TableRow key={index}>
                                    <TableCell><Link to={link}>{row.name}</Link></TableCell>
                                    <TableCell>{dateString}</TableCell>
                                    <TableCell>{formatNumber(row.income)}</TableCell>
                                    <TableCell>{formatNumber(row.cost)}</TableCell>
                                    <TableCell>{row.payed ? 'Оплачено' : 'Не оплачено'}</TableCell>
                                </TableRow>
                            )
                        })}
                        {filteredData.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={3} align="center">Анкет не найдено</TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
}